import { useEffect, useState } from 'react';

/**
 * Whether an element is currently on screen. Returns a callback ref rather than taking a ref object, so
 * observation follows the element when it remounts or is swapped for another one.
 */
export const useIsInView = () => {
  const [element, setElement] = useState<Element | null>(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    if (!element) {
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      setIsInView(entry?.isIntersecting ?? false);
    });

    observer.observe(element);

    return () => {
      observer.disconnect();
      // A replacement element starts unseen; its own first callback reports where it actually is.
      setIsInView(false);
    };
  }, [element]);

  return { isInView, ref: setElement };
};
